import { z } from "zod";
import { DTOBrand, DTODesignSystem, DTODesignSystemVersion } from "../design-systems";
import { DTOUserWorkspaceMembership } from "../workspaces";

export const DTOAppBootstrapDataQuery = z.object({
  preferredWorkspaceId: z.string().optional(),
  preferredDesignSystemId: z.string().optional(),
  preferredVersionId: z.string().optional(),
  preferredBrandId: z.string().optional(),
});

export const DTOAppBootstrapDataResponse = z.object({
  workspaceMembership: DTOUserWorkspaceMembership.optional(),
  designSystem: DTODesignSystem.optional(),
  version: DTODesignSystemVersion.optional(),
  brand: DTOBrand.optional(),
});

export type DTOAppBootstrapDataQuery = z.infer<typeof DTOAppBootstrapDataQuery>;
export type DTOAppBootstrapDataResponse = z.infer<typeof DTOAppBootstrapDataResponse>;
